var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeadsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    transform: "matrix(-1 0 0 1 22 0)",
    fill: "#2563EB",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2728_34668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0126 14.5436C10.3593 14.5436 9.7043 14.5612 9.05247 14.5436C8.18494 14.5158 7.85199 14.0018 8.1865 13.2462C8.41889 12.7251 8.81121 12.2804 9.31371 11.9685C9.81621 11.6566 10.4063 11.4915 11.009 11.4942C11.6118 11.4968 12.2002 11.6671 12.6995 11.9835C13.1988 12.2998 13.5867 12.748 13.8138 13.2711C14.1092 13.9681 13.7622 14.5114 12.9666 14.5436C12.321 14.57 11.666 14.5436 11.0126 14.5436Z",
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4694 9.61758C12.4835 10.4713 11.8441 11.1596 11.0297 11.1772C10.2153 11.1948 9.54164 10.5284 9.52757 9.67762C9.5135 8.8268 10.1528 8.13705 10.9657 8.11948C11.7785 8.10191 12.4553 8.76529 12.4694 9.61758Z",
    fill: "#65769A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27801 9.33039C6.07637 8.98625 6.13577 8.76073 6.59064 8.71094C6.61396 8.72304 6.63594 8.73727 6.65629 8.75341C6.88138 8.98772 7.54102 9.01408 7.29248 9.44901C6.99549 9.97327 6.62815 9.36114 6.27801 9.33039Z",
    fill: "#65769A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4015 8.71094C15.8579 8.76073 15.9173 8.98772 15.7141 9.33039C15.6188 9.37432 15.525 9.42118 15.4281 9.46218C15.1748 9.57201 14.8872 9.83414 14.6778 9.46218C14.4965 9.13855 14.8638 9.05508 15.0607 8.91596C15.1702 8.83249 15.289 8.7783 15.4015 8.71094Z",
    fill: "#65769A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59116 14.2607C6.14567 14.2065 6.07064 13.9869 6.27853 13.6427C6.35044 13.612 6.42234 13.5783 6.49581 13.5505C6.76623 13.445 7.07417 13.0936 7.3102 13.5139C7.50872 13.8668 7.07417 13.9415 6.86002 14.0996C6.76936 14.1553 6.68026 14.2051 6.59116 14.2607Z",
    fill: "#65769A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7201 13.6448C15.9249 13.989 15.8514 14.2086 15.4075 14.2628C15.3842 14.2507 15.3622 14.2365 15.3418 14.2203C15.1152 13.986 14.454 13.9582 14.7041 13.5233C15.0026 12.999 15.3684 13.6141 15.7201 13.6448Z",
    fill: "#65769A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6504 6.58701C10.8817 6.19162 11.1193 6.19308 11.3444 6.58701C11.3444 6.68513 11.3335 6.78324 11.3257 6.87989C11.3053 7.13763 11.4023 7.50227 10.9583 7.47298C10.5941 7.44808 10.6848 7.11566 10.6692 6.88721C10.6613 6.78178 10.6566 6.68513 10.6504 6.58701Z",
    fill: "#65769A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3444 16.3851C11.1131 16.779 10.8755 16.7805 10.6504 16.3851C10.6504 16.287 10.6613 16.1889 10.6692 16.0922C10.6895 15.8359 10.591 15.4698 11.0349 15.5065C11.3991 15.5313 11.31 15.8638 11.3257 16.0922L11.3444 16.3851Z",
    fill: "#65769A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8206 9.61108C11.7799 10.0914 11.5892 10.5132 11.0484 10.541C10.4513 10.5717 10.1965 10.1485 10.1934 9.64037C10.1934 9.1615 10.4403 8.76172 10.9874 8.76172C11.5345 8.76172 11.7424 9.15711 11.8206 9.61108Z",
    fill: "#F9F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9943 6.66816C11.7808 6.66816 12.4183 6.07087 12.4183 5.33408C12.4183 4.59729 11.7808 4 10.9943 4C10.2079 4 9.57031 4.59729 9.57031 5.33408C9.57031 6.07087 10.2079 6.66816 10.9943 6.66816Z",
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.34003 9.66035C6.12649 9.66035 6.76404 9.06306 6.76404 8.32627C6.76404 7.58948 6.12649 6.99219 5.34003 6.99219C4.55357 6.99219 3.91602 7.58948 3.91602 8.32627C3.91602 9.06306 4.55357 9.66035 5.34003 9.66035Z",
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.34003 15.8908C6.12649 15.8908 6.76404 15.2935 6.76404 14.5567C6.76404 13.8199 6.12649 13.2227 5.34003 13.2227C4.55357 13.2227 3.91602 13.8199 3.91602 14.5567C3.91602 15.2935 4.55357 15.8908 5.34003 15.8908Z",
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9943 19.0002C11.7808 19.0002 12.4183 18.4029 12.4183 17.6661C12.4183 16.9293 11.7808 16.332 10.9943 16.332C10.2079 16.332 9.57031 16.9293 9.57031 17.6661C9.57031 18.4029 10.2079 19.0002 10.9943 19.0002Z",
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6584 15.9807C17.4448 15.9807 18.0824 15.3834 18.0824 14.6466C18.0824 13.9098 17.4448 13.3125 16.6584 13.3125C15.8719 13.3125 15.2344 13.9098 15.2344 14.6466C15.2344 15.3834 15.8719 15.9807 16.6584 15.9807Z",
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6584 9.66035C17.4448 9.66035 18.0824 9.06306 18.0824 8.32627C18.0824 7.58948 17.4448 6.99219 16.6584 6.99219C15.8719 6.99219 15.2344 7.58948 15.2344 8.32627C15.2344 9.06306 15.8719 9.66035 16.6584 9.66035Z",
    fill: "#2563EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2728_34668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.1667,
    height: 15,
    fill: "white",
    transform: "translate(3.91602 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadsIcon);
export default __webpack_public_path__ + "static/media/Leads-Icon.2d0ee233f3bad94b3a78af7d8a90dd6e.svg";
export { ForwardRef as ReactComponent };